export const useElementRect = (selector) => {
  const _scroller = inject("scroller")
  const { app } = useStores()

  const scroller = computed(() => {
    if (_scroller && _scroller.value) return _scroller.value
    return app.scroller
  })

  const ele = useSelectElement(selector)
  const bounds = reactive({
    _top: 0,
    top: 0,
    _left: 0,
    left: 0,
    width: 1,
    height: 1,
  })

  // ************************************************************
  // Recalc Bounds
  // ************************************************************

  const recalc = () => {
    if (!ele.value) {
      bounds._top = 0
      bounds.top = 0
      bounds._left = 0
      bounds.left = 0
      bounds.width = 1
      bounds.height = 1
      return
    }

    const rect = ele.value.getBoundingClientRect()

    const scrollTop = scroller.value?.scroll || 0
    const scrollLeft = ele.value?.flkty?.value?.x || 0
    // console.log(100, scrollLeft)

    bounds._top = rect.top + scrollTop
    bounds.top = rect.top
    bounds._left = rect.left - scrollLeft
    bounds.left = rect.left
    bounds.width = rect.width || 1
    bounds.height = rect.height || 1
  }

  watch(() => ele.value, recalc)
  watch(() => scroller.value, recalc)
  useResize2(recalc)
  usePageReady(recalc)
  onMounted(recalc)

  // ************************************************************
  // On page scroll
  // ************************************************************
  const onScroll = () => {
    if (!ele.value) {
      bounds.top = 0
      return
    }
    bounds.top = bounds._top - (scroller.value?.scroll || 0)
  }
  onMounted(() => {
    if (scroller.value) scroller.value.on("scroll", onScroll)
  })
  onBeforeUnmount(() => {
    if (scroller.value) scroller.value.off("scroll", onScroll)
  })

  // ************************************************************
  // On carousel update
  // ************************************************************
  const { onBeforeLoop, onLoop } = useRenderLoop()
  onBeforeLoop(() => {
    if (ele.value?.flkty?.value?.x != undefined) {
      bounds.left = bounds._left + ele.value.flkty.value.x
    }
  })

  return bounds
}
